export const UpsellTrackingEvents = {
  sheetDismissed: 'Upsell Sheet Dismissed',
  sheetOpened: 'Upsell Sheet Opened',
  upgradeClicked: 'Upsell Sheet Upgrade Clicked',
} as const

/**
 * Identifies which gated control opened the upsell sheet. Threaded through
 * `openUpsellSheet` so the open/dismiss/upgrade events can be attributed to the
 * pro button that triggered them.
 */
export const UpsellSource = {
  deliveryCatering: 'delivery_catering',
  homeDashboardBanner: 'home_dashboard_banner',
  marketingAutomatedCampaign: 'marketing_automated_campaign',
  marketingSmsCreate: 'marketing_sms_create',
  navSidebar: 'nav_sidebar',
  settingsDeliveryCatering: 'settings_delivery_catering',
  settingsMarketingSms: 'settings_marketing_sms',
  settingsMobile: 'settings_mobile',
  settingsOrderingOptionsCatering: 'settings_ordering_options_catering',
  websiteBuilderReservationEmbed: 'website_builder_reservation_embed',
  websiteBuilderReservationEmbedAdd: 'website_builder_reservation_embed_add',
} as const

export type UpsellSourceValue = (typeof UpsellSource)[keyof typeof UpsellSource]
